/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    DatalistAnagrafica,
    Paginator, Rilievo
} from '@models';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { RilievoService } from '@shared/services/rilievo.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-toolkit-opera-modal-piano-rilievi',
    templateUrl: './modal-piano-rilievi.component.html',
})
export class ToolkitGestioneOperaModalPianoRilieviComponent implements OnInit {
    
    @Input() canEdit: boolean;
    @Input() azione: string;
    @Input() formOpera: FormGroup;
    @Input() currentRilievo: Rilievo | null;
    @Input() datalist: DatalistAnagrafica;

    public criteriaForm: FormGroup;
    public tableDataRilievo: Rilievo[] = [];
    public paginatorRilievo: Paginator = new Paginator();
    public modalCreaRilievo: NgbModalRef;

    get ricercaRilievoDTO() { return this.criteriaForm.controls['ricercaRilievoDTO'] as FormGroup; }
    get inserisciRilievoDTO() { return this.criteriaForm.controls['inserisciRilievoDTO'] as FormGroup; }
    
    constructor(
        public activeModal: NgbActiveModal,
        private operaService: OperaService,
        private fb: FormBuilder,
        private rilievoService: RilievoService,
        private utilsService: UtilsService,
        private modalService: NgbModal,
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            ricercaRilievoDTO:this.rilievoService.generateFormRicercaRilievo(),
            inserisciRilievoDTO: this.rilievoService.generateFormRilievo()
        });
        // if (this.params) {
        //     this.pianoRilDTO.patchValue(this.params);
        // }
        if (!this.canEdit) {
            this.criteriaForm.disable();
        }
    }

    public savePianoRilievi() {
        // if (this.pianoInterventoDTO.invalid) {
        //     this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
        //     return;
        // }
        // this.activeModal.close(this.pianoInterventoDTO);
        this.activeModal.close(this.currentRilievo);
    }

    /* Rilievo: ricerca */
    public resetFormRicercaRilievo() {
        this.paginatorRilievo.resetPaginator();
        this.tableDataRilievo = [];
        this.ricercaRilievoDTO.reset();
        this.currentRilievo = null;
        this.formOpera.get('idRilievo')?.setValue(null);
    }
    
    public submitFormRicercaRilievo(fromBtn?: boolean) {
        if(fromBtn) {
            this.paginatorRilievo.resetPaginator();
        }
        this.rilievoService.search(this.ricercaRilievoDTO.getRawValue(), this.paginatorRilievo.getQueryPaginator([])).subscribe(response => {
            this.tableDataRilievo = [...response.content];
            this.paginatorRilievo.setTotalPage(response.totalElements);
        });
    }
    public onPageChangeRilievo($event: number) {
        this.paginatorRilievo.page = $event;
        this.submitFormRicercaRilievo();
    }
    
    public selezionaRilievo(item: Rilievo) {
        this.currentRilievo = item;
    }

    /* Rilievo: inserimento */
    public creaRilievo(content: any) {
        this.modalCreaRilievo = this.modalService.open(content, { size: 'xl' });
    }

    public creaRilievo_confirm() {
        if (this.inserisciRilievoDTO.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            this.inserisciRilievoDTO.markAllAsTouched();
            return;
        }
        this.rilievoService.create(this.inserisciRilievoDTO.getRawValue()).subscribe(response => {
            this.selezionaRilievo(response);
            this.modalCreaRilievo.close();
        });
    }

}
